import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Subfee.Save.IRequest;
type Response = Api.Core.Subfee.Save.IResponse;
type Headers = Api.Core.Subfee.Save.IHeaders;
const url = '/api/ProductManagement/Subfee';
export default async function productSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: body?.id ? HttpMethod.put : HttpMethod.post,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
